import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconPublishSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.66665C2 1.93027 2.59695 1.33331 3.33333 1.33331H11.3333C12.8061 1.33331 14 2.52722 14 3.99998V13.3333C14 14.0697 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0697 2 13.3333V2.66665ZM8.66667 13.3333V8.27612L9.5286 9.13805C9.78895 9.3984 10.2111 9.3984 10.4714 9.13805C10.7318 8.8777 10.7318 8.45559 10.4714 8.19524L8.47141 6.19524C8.21106 5.93489 7.78895 5.93489 7.52859 6.19524L5.5286 8.19524C5.26825 8.45559 5.26825 8.8777 5.5286 9.13805C5.78894 9.3984 6.21106 9.3984 6.47141 9.13805L7.33333 8.27612V13.3333H3.33333V2.66665L9.33333 2.66665V4.66665C9.33333 5.40303 9.93029 5.99998 10.6667 5.99998H12.6667V13.3333H8.66667ZM11.3333 2.66665C12.0697 2.66665 12.6667 3.2636 12.6667 3.99998V4.66665H10.6667V2.66665H11.3333Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
